import styled from 'styled-components'
import { breakPointsCss, colors, measurments } from '../utils/config'

export const AppStylesProvider = styled.div`
  background: ${colors.gray200};
  min-height: 100vh;
  .content {
    max-width: ${measurments.contentWidth}px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  main {
    padding-top: 4rem;
    padding-left: ${measurments.internalNavWidth}px;
    &.is-editor {
      padding-left: 0;
      padding-top: 0;
    }
  }
  .primblue {
    color: ${colors.primary400};
  }
  .red {
    color: ${colors.error400};
  }
  .label {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${colors.gray700};
    font-weight: 500;
    &.light {
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 400;
      color: ${colors.gray700};
    }
  }
  .desc {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.gray600};
    margin-bottom: 0.4rem;
    &.light {
      font-size: 0.75rem;
      line-height: 1rem;
      font-weight: 400;
      color: ${colors.gray600};
      margin-bottom: 0.25rem;
    }
  }
  ${breakPointsCss.tablet} {
    main {
      padding-left: 0;
    }
  }
`
